import { motion } from 'framer-motion';
import { Users, Phone, DollarSign, type LucideIcon } from 'lucide-react';

interface Stat {
  value: string;
  label: string;
  icon: LucideIcon;
  color: string;
}

const stats: Stat[] = [
  {
    value: '40% More',
    label: 'Leads Captured',
    icon: Users,
    color: 'text-brand-accent',
  },
  {
    value: '< 30 Sec',
    label: 'Avg Response Time',
    icon: Phone,
    color: 'text-green-400',
  },
  {
    value: '10x ROI',
    label: 'Within First Month',
    icon: DollarSign,
    color: 'text-brand-primary',
  },
];

export const StatsBar = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
      className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-6 sm:gap-8 mb-12 p-6 rounded-2xl bg-brand-base/30 border border-brand-border/50 backdrop-blur-sm"
    >
      {stats.map((stat, index) => (
        <motion.div
          key={stat.label}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5 + index * 0.1, duration: 0.3 }}
          className="flex items-center gap-3"
        >
          <div className={`p-2 rounded-lg bg-brand-dark/50 ${stat.color}`}>
            <stat.icon className="w-5 h-5" />
          </div>
          <div>
            <div className={`text-2xl font-bold ${stat.color} font-display`}>
              {stat.value}
            </div>
            <div className="text-xs text-slate-400 font-medium uppercase tracking-wide">
              {stat.label}
            </div>
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
};
